<div class="min-term-wrapper">
  <h3 class="sub-heading">No minimum term</h3>
  <p>
    Cover continues for as long as you like with monthly Direct Debit payments.
    If you have added multiple appliances to your quote, each appliance will be
    a separate policy. This means you can cancel each individual appliance
    policy whenever you choose to.
  </p>
</div>
